import * as React from "react";
import { KeyboardButtonDefinition } from "./KeyboardButton";

export const KeyboardContext = React.createContext<
    (button: KeyboardButtonDefinition) => void
>(() => {
    // no implementation needed
});
